export default __webpack_public_path__ + "img/d2e0a3dec9840a2c1bfa685fe876d21d.svg";